// src/context/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase"; 
import { authService } from "../services/authService"; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        try {
          const userData = await authService.getUserData(user.uid);
          
          if (userData && (userData.isAdmin === true || userData.role === 'admin')) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error("Kullanıcı verisi alınırken hata:", error);
          setIsAdmin(false);
        }
      } else {
        setCurrentUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = (email, password) => authService.login(email, password);
  
  // ✅ YENİ: legalData (Hukuki Onay Logları) parametresi eklendi
  const register = (email, password, name, surname, phone, marketingConsent, legalData) => 
    authService.register(email, password, name, surname, phone, marketingConsent, legalData);
    
  const logout = () => authService.logout();

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        isAdmin,
        loading,
        login,    
        register, 
        logout    
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);